import React, { FunctionComponent } from 'react';
import { useSwipeable } from 'react-swipeable';
import { FormattedMessage } from 'react-intl';
import { IBindingAction } from '../../../../common/models/callback';
import RegularButton from '../../../../components/RegularButton';
import { ReactComponent as ArrowRight } from '../../../../assets/icons/arrow-right.svg';
import styles from './styles.module.scss';
import { WorkspaceState } from '../../../../reducers/workspace';

interface IIntroPageProps {
  workspace: WorkspaceState;
  firstName: string;
  onStart: IBindingAction;
}

const IntroPage: FunctionComponent<IIntroPageProps> = ({
  firstName,
  workspace: { name, logo },
  onStart
}) => {
  const swipeHandler = useSwipeable({
    onSwipedLeft: onStart,
    trackMouse: false
  });

  return (
    <div {...swipeHandler} className="d-flex flex-column justify-content-center align-items-center">
      {logo
        ? (
          <img
            src={logo}
            alt="company logo"
            className={styles.img}
          />
        )
        : name}
      <div className={`text-center cf-title ${styles.title}`}>
        <FormattedMessage
          id="candidateForm.intro.title"
          defaultMessage="Hi, {firstName}!"
          values={{ firstName }}
        />
      </div>
      <div className="row justify-content-center">
        <div className={`col-sm-12 col-md-5 text-center cf-subtitle ${styles.subtitle}`}>
          <FormattedMessage
            id="candidateForm.intro.subtilte"
            defaultMessage={`As a part of your recruiting process,
            we would like for you to provide contact information for your references
            so that we can speak to the people who know you best`}
          />
        </div>
      </div>
      <RegularButton
        size="lg"
        textIntlId="candidateForm.getStarted"
        defaultMessage="Get Started"
        icon={<ArrowRight />}
        iconPosition="right"
        onClick={onStart}
      />
    </div>
  );
};
export default IntroPage;
